<template>
  <Panel
    :icon="['fas', 'link']"
    :loading="loading"
    loader-text="Loading Ringba Integration Settings"
  >
    <template #header>
      Ringba Integration
    </template>
    <template #content>
      <div class="integration-settings">
        <ManageRingbaApiToken />

        <SelectedWebhookDisplay
          v-if="accountHasRingbaIntegrationCompleted"
          :account-id="accountId"
        />
      </div>
    </template>
  </Panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ManageRingbaApiToken from './ManageRingbaApiToken.vue'
import SelectedWebhookDisplay from './SelectedWebhookDisplay.vue'

export default {
  name: 'RingbaIntegration',

  title: 'Ringba Integration',

  components: {
    ManageRingbaApiToken,
    SelectedWebhookDisplay
  },
  
  data() {
    return {
      loading: false,
      fetchTokensError: null
    }
  },
  
  computed: {
    ...mapGetters('auth', ['accountId']),
    ...mapGetters('account', ['accountHasRingbaIntegrationCompleted'])
  },
  
  async created() {
    await this.fetchRingbaTokens()
  },
  
  methods: {
    ...mapActions('ringbaTokens', ['fetchTokens']),
    
    async fetchRingbaTokens() {
      this.loading = true
      this.fetchTokensError = null
      
      try {
        await this.fetchTokens({ accountId: this.accountId })
      } catch (error) {
        this.fetchTokensError = 'Failed to load Ringba tokens'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Panel component handles the main layout styling
</style>